import React from 'react';
import './how-to-order.css'; // Assuming you'll add some styling

function HowToOrder() {
  return (
    <div className="how-to-order">
      <h1>How to Order</h1>
      <h3>Follow these simple steps to place your order and get your product delivered:</h3>

      <div className="order-steps">
        <div className="step">
          <h2>Step 1: Browse Our Products</h2>
          <p>Visit our website and browse through the collection of our high-quality products. Choose the product that you want to purchase.</p>
        </div>

        <div className="step">
          <h2>Step 2: Place Your Order</h2>
          <p>Click on the "Order Now" button for the selected product. You'll be prompted to enter your shipping details such as address, city, state, and pincode.</p>
        </div>

        <div className="step">
          <h2>Step 3: Make Payment</h2>
          <p>To complete your order, make the payment directly through UPI (PhonePe, Google Pay, etc.) to the following UPI ID or phone number:</p>
          <div className="payment-method">
            <p><strong>UPI ID/Phone Number:</strong> [7828215766]</p> 
            <p>Use any UPI payment app to complete the payment.</p>
            <p><strong>Note:</strong> Please ensure the payment is successful before proceeding to the next step.</p>
          </div>
        </div>

        <div className="step">
          <h2>Step 4: Send Payment Receipt</h2>
          <p>After completing the payment, take a screenshot or save the payment receipt from your UPI app (PhonePe, Google Pay, etc.).</p>
          <p>Then, send the payment receipt to us on WhatsApp at the following number:</p>
          <div className="whatsapp-info">
            <p><strong>WhatsApp Number:</strong> [+917828215766]</p>
          </div>
        </div>

        <div className="step">
          <h2>Step 5: Order Confirmation</h2>
          <p>Once we receive your payment receipt on WhatsApp, we will verify the payment and confirm your order. You will receive a confirmation message with your order details.</p>
        </div>

        <div className="step">
          <h2>Step 6: Delivery</h2>
          <p>Your order will be processed and delivered to the address you provided. You will receive tracking details once your order is shipped.</p>
        </div>
      </div>

      <div className="contact-info">
        <p>If you have any questions or need assistance, feel free to contact us:</p>
        <ul>
          <li>WhatsApp: <a href={`https://wa.me/+917828215766`} target="_blank" rel="noopener noreferrer">[+917828215766]</a></li>
          <li><strong>Email:</strong> <a href="mailto:sonadevibhadoriya@gmail.com">sonadevibhadoriya@gmail.com</a></li>
        </ul>
      </div>

      <div className="disclaimer">
        <p><strong>Disclaimer:</strong> Please double-check your payment before sending the receipt. If you face any issues, contact us immediately via WhatsApp.</p>
      </div>
    </div>
  );
}

export default HowToOrder;
